import { selectDevice } from 'entities/device/lib';
export const privateDeviceName = (device_id) => (state) => selectDevice(state, device_id)?.individual_device_name ?? '';
export const privateDeviceNote = (device_id) => (state) => selectDevice(state, device_id)?.individual_device_note ?? '';
